<template>

<div class="component-wrap">


  <AppContentHeader headline="End of Market Disposition Report">

		</AppContentHeader>


  <div class="md-layout md-gutter emd-layout">
    <div class="md-layout-item md-size-25">
      <md-field>
        <label>Select season</label>
        <md-select v-model="selectedSeason" name="Select season" id="season">
          <md-option
            v-for="(season) in seasons"
            :key="season.seasons_id"
            :value="season.seasons_id"
          >
            {{ season.seasons_name }}
          </md-option>
        </md-select>
      </md-field>
    </div>
    <div class="md-layout-item md-size-40">
      <div class="emd-field">
        <md-field>
          <label>End of Market Disposition</label>
          <md-select v-model="selectedEmd" name="Select EMD" id="emd" :md-placeholder="'Select disposition'">
            <md-option :value="1">Leave Installed</md-option>
            <md-option :value="2">Remove / Trash</md-option>
            <md-option :value="3">Store in Staging</md-option>
          </md-select>
          <md-button v-if="selectedEmd" class="md-icon-button md-dense emd-clear" @click="selectedEmd = null" title="Clear selection">
            <md-icon>close</md-icon>
          </md-button>
        </md-field>
      </div>
    </div>
  </div>

  <md-button class="md-primary md-raised download-button" @click="downloadReport">DOWNLOAD</md-button>
  <md-snackbar :md-active.sync="snackbar" md-persistent md-prompt>
    You need to select a season first.
  </md-snackbar>
</div>
</template>

<script>


export default {
  name: 'ReportsDashboardEndOfMarket',
  data: () => ({
    seasons: [],
    selectedSeason: null,
    snackbar: false,
    selectedEmd: null,
  }),

  components: {},

  methods: {
    downloadReport() {
      if (!this.selectedSeason) {
        this.snackbar = true;
        return;
      }
      let url = `/sponsorships/end-market-disposition/export?season_id=${this.selectedSeason}`;
      if (this.selectedEmd && this.selectedEmd !== 0) {
        url += `&emd=${this.selectedEmd}`;
      }
      this.$axios.get(url)
        .then(res => {
          window.open(res.data);
        })
        .catch(err => {
          console.log(err);
        });
    },

    getSeasons() {
      return this.$axios.get(`/seasons`)
        .then(res => {
          this.seasons = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },

    async loadData() {
      await this.getSeasons();
    }
  },

  created() {
    this.loadData();
  }
}
</script>

<style lang="scss" scoped>

  .download-button {
		margin-top: 4rem;
		box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
		border-radius: 4px;
	}

  .emd-field {
    position: relative;
  }

  .emd-field .md-input {
    padding-right: 3.5rem;
  }

  .emd-clear {
    position: absolute;
    right: 2.25rem;
    top: 1.75rem;
    z-index: 2;
    width: 28px;
    height: 28px;
    min-width: 28px;
    min-height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 600px) {
    .emd-field .md-field > label {
      white-space: normal;
    }

    .emd-layout {
      flex-direction: column;
    }

    .emd-layout .md-layout-item {
      min-width: 100%;
    }
  }
</style>